export interface TreeMapPoint {
  id: string;
  codigoCta: string;
  nomePopular: string;
  nomeCientifico: string;
  tipo: string;
  especie: string;
  estadoFitossanitario: string;
  classeRisco: string;
  recomendacao: string;
  dap: number;
  altura: number;
  bairro: string;
  logradouro: string;
  numero: string;
  latitude: number;
  longitude: number;
  projeto: string;
  tecnico: string;
  ultimaVistoria: string;
  fotos: number;
  statusRevisao: string;
  fotoUrl: string;
  camada: string[];
}

export interface AreaVerdeMap {
  id: string;
  nome: string;
  tipo: string;
  area: number;
  arvoresDentro: number;
  riscoCritico: number;
  co2eEstimado: number;
  bairro: string;
  latitude: number;
  longitude: number;
  coordenadas: [number, number][];
  documentosVinculados: number;
  status: string;
  camada: string[];
}

export interface UCMap {
  id: string;
  nome: string;
  tipo: string;
  area: number;
  arvoresDentro: number;
  riscoCritico: number;
  co2eEstimado: number;
  bairro: string;
  latitude: number;
  longitude: number;
  coordenadas: [number, number][];
  documentosVinculados: number;
  status: string;
  orgaoGestor: string;
  camada: string[];
}

export interface ProjetoMapArea {
  id: string;
  nome: string;
  latitude: number;
  longitude: number;
  coordenadas: [number, number][];
  camada: string[];
}

export interface MapLayer {
  id: string;
  nome: string;
  icone: string;
  cor: string;
  ativa: boolean;
  categoria: string;
}

export const mapaLayers: MapLayer[] = [
  { id: "arvores", nome: "Árvores cadastradas", icone: "ri-plant-line", cor: "#1B6E4F", ativa: true, categoria: "individuos" },
  { id: "palmeiras", nome: "Palmeiras", icone: "ri-leaf-line", cor: "#2E8B57", ativa: true, categoria: "individuos" },
  { id: "mudas", nome: "Mudas", icone: "ri-seedling-line", cor: "#4CAF50", ativa: true, categoria: "individuos" },
  { id: "risco_medio", nome: "Risco médio", icone: "ri-alert-line", cor: "#FBC02D", ativa: true, categoria: "risco" },
  { id: "risco_alto", nome: "Risco alto", icone: "ri-error-warning-line", cor: "#F57C00", ativa: true, categoria: "risco" },
  { id: "risco_critico", nome: "Risco crítico", icone: "ri-close-circle-line", cor: "#D32F2F", ativa: true, categoria: "risco" },
  { id: "poda_recomendada", nome: "Poda recomendada", icone: "ri-scissors-line", cor: "#E67E22", ativa: false, categoria: "manejo" },
  { id: "supressao", nome: "Supressão recomendada", icone: "ri-delete-bin-line", cor: "#C62828", ativa: false, categoria: "manejo" },
  { id: "areas_verdes", nome: "Áreas verdes", icone: "ri-landscape-line", cor: "#64B5F6", ativa: true, categoria: "ambiental" },
  { id: "ucs", nome: "Unidades de Conservação", icone: "ri-shield-star-line", cor: "#1565C0", ativa: true, categoria: "ambiental" },
  { id: "projetos", nome: "Projetos de inventário", icone: "ri-folder-chart-line", cor: "#1B6E4F", ativa: false, categoria: "projetos" },
  { id: "carbono", nome: "Áreas de carbono", icone: "ri-cloud-line", cor: "#00897B", ativa: false, categoria: "projetos" },
  { id: "bairros", nome: "Bairros", icone: "ri-map-pin-line", cor: "#B0BEC5", ativa: false, categoria: "base" },
  { id: "logradouros", nome: "Logradouros", icone: "ri-road-map-line", cor: "#90A4AE", ativa: false, categoria: "base" },
];

export const arvoresMapa: TreeMapPoint[] = [
  {
    id: "MAP-001", codigoCta: "CTA-GO-5208707-BV0001", nomePopular: "Ipê-amarelo", nomeCientifico: "Handroanthus chrysotrichus",
    tipo: "Árvore", especie: "Handroanthus chrysotrichus", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 45, altura: 12.5, bairro: "Setor Bela Vista", logradouro: "Av. Bela Vista", numero: "450",
    latitude: -16.7145, longitude: -49.2610, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Carlos Mendes", ultimaVistoria: "2026-06-25", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Adult%20golden%20trumpet%20tree%20Handroanthus%20on%20urban%20sidewalk%2C%20green%20canopy%2C%20professional%20arboriculture%20photo%2C%20clean%20urban%20background&width=400&height=300&seq=map-bv-ipe-001&orientation=landscape",
    camada: ["arvores", "risco_baixo"]
  },
  {
    id: "MAP-002", codigoCta: "CTA-GO-5208707-BV0002", nomePopular: "Sibipiruna", nomeCientifico: "Caesalpinia pluviosa",
    tipo: "Árvore", especie: "Caesalpinia pluviosa", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Poda de limpeza", dap: 52, altura: 14.0, bairro: "Setor Bela Vista", logradouro: "Rua das Acácias", numero: "120",
    latitude: -16.7158, longitude: -49.2625, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-06-18", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Sibipiruna%20tree%20Caesalpinia%20on%20urban%20sidewalk%20with%20spreading%20canopy%2C%20professional%20arboriculture%20photo%2C%20natural%20light&width=400&height=300&seq=map-bv-sibipiruna-002&orientation=landscape",
    camada: ["arvores", "risco_medio"]
  },
  {
    id: "MAP-003", codigoCta: "CTA-GO-5208707-BV0003", nomePopular: "Oiti", nomeCientifico: "Licania tomentosa",
    tipo: "Árvore", especie: "Licania tomentosa", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 38, altura: 9.8, bairro: "Setor Bela Vista", logradouro: "Praça da Bela Vista", numero: "s/n",
    latitude: -16.7132, longitude: -49.2595, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Rafael Torres", ultimaVistoria: "2026-06-20", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Oiti%20tree%20Licania%20tomentosa%20in%20urban%20park%20with%20dense%20green%20canopy%2C%20professional%20arboriculture%20documentation%2C%20bright%20daylight&width=400&height=300&seq=map-bv-oiti-003&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-004", codigoCta: "CTA-GO-5208707-BV0004", nomePopular: "Mangueira", nomeCientifico: "Mangifera indica",
    tipo: "Árvore", especie: "Mangifera indica", estadoFitossanitario: "regular", classeRisco: "alto",
    recomendacao: "Poda corretiva", dap: 78, altura: 18.2, bairro: "Setor Bela Vista", logradouro: "Rua dos Ipês", numero: "890",
    latitude: -16.7175, longitude: -49.2638, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-15", fotos: 6, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Large%20mango%20tree%20Mangifera%20indica%20in%20park%20setting%2C%20wide%20canopy%2C%20professional%20arboriculture%20photo%2C%20natural%20daylight&width=400&height=300&seq=map-bv-manga-004&orientation=landscape",
    camada: ["arvores", "risco_alto"]
  },
  {
    id: "MAP-005", codigoCta: "CTA-GO-5208707-BV0005", nomePopular: "Palmeira-imperial", nomeCientifico: "Roystonea oleracea",
    tipo: "Palmeira", especie: "Roystonea oleracea", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 35, altura: 22.0, bairro: "Setor Bela Vista", logradouro: "Av. Bela Vista", numero: "780",
    latitude: -16.7138, longitude: -49.2605, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Carlos Mendes", ultimaVistoria: "2026-06-28", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Imperial%20palm%20tree%20Roystonea%20oleracea%20tall%20straight%20trunk%20on%20urban%20avenue%2C%20clear%20blue%20sky%2C%20professional%20photo&width=400&height=300&seq=map-bv-palmeira-005&orientation=landscape",
    camada: ["palmeiras"]
  },
  {
    id: "MAP-006", codigoCta: "CTA-GO-5208707-BV0006", nomePopular: "Flamboyant", nomeCientifico: "Delonix regia",
    tipo: "Árvore", especie: "Delonix regia", estadoFitossanitario: "ruim", classeRisco: "critico",
    recomendacao: "Supressão", dap: 28, altura: 8.5, bairro: "Setor Bela Vista", logradouro: "Rua Copacabana", numero: "234",
    latitude: -16.7192, longitude: -49.2665, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-06-10", fotos: 7, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Flamboyant%20tree%20Delonix%20regia%20with%20damaged%20trunk%20on%20residential%20street%2C%20inclined%20posture%2C%20professional%20arboriculture%20risk%20assessment%20photo&width=400&height=300&seq=map-bv-flamboyant-006&orientation=landscape",
    camada: ["arvores", "risco_critico", "supressao"]
  },
  {
    id: "MAP-007", codigoCta: "CTA-GO-5208707-BV0007", nomePopular: "Jacarandá-mimoso", nomeCientifico: "Jacaranda mimosifolia",
    tipo: "Árvore", especie: "Jacaranda mimosifolia", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 32, altura: 10.2, bairro: "Setor Bela Vista", logradouro: "Alameda dos Buritis", numero: "350",
    latitude: -16.7118, longitude: -49.2580, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-22", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jacaranda%20tree%20with%20purple%20flowers%20on%20urban%20street%2C%20graceful%20canopy%2C%20professional%20arboriculture%20photography%2C%20bright%20sunlight&width=400&height=300&seq=map-bv-jacaranda-007&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-008", codigoCta: "CTA-GO-5208707-BV0008", nomePopular: "Pau-brasil", nomeCientifico: "Paubrasilia echinata",
    tipo: "Árvore", especie: "Paubrasilia echinata", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 22, altura: 7.0, bairro: "Setor Bela Vista", logradouro: "Praça da Bela Vista", numero: "s/n",
    latitude: -16.7140, longitude: -49.2588, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Fernanda Lima", ultimaVistoria: "2026-06-15", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Pau%20brasil%20tree%20in%20protected%20natural%20area%2C%20young%20specimen%20with%20green%20foliage%2C%20professional%20botanical%20documentation%2C%20natural%20light&width=400&height=300&seq=map-bv-paubrasil-008&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-009", codigoCta: "CTA-GO-5208707-BV0009", nomePopular: "Ficus", nomeCientifico: "Ficus benjamina",
    tipo: "Árvore", especie: "Ficus benjamina", estadoFitossanitario: "ruim", classeRisco: "critico",
    recomendacao: "Poda emergencial", dap: 92, altura: 20.5, bairro: "Setor Bela Vista", logradouro: "Rua das Palmeiras", numero: "560",
    latitude: -16.7165, longitude: -49.2640, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-12", fotos: 9, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Large%20Ficus%20benjamina%20tree%20with%20extensive%20root%20system%20damaging%20sidewalk%2C%20professional%20arboriculture%20risk%20assessment%20photo%2C%20urban%20context&width=400&height=300&seq=map-bv-ficus-009&orientation=landscape",
    camada: ["arvores", "risco_critico", "poda_recomendada"]
  },
  {
    id: "MAP-010", codigoCta: "CTA-GO-5208707-BV0010", nomePopular: "Quaresmeira", nomeCientifico: "Tibouchina granulosa",
    tipo: "Árvore", especie: "Tibouchina granulosa", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 18, altura: 5.5, bairro: "Setor Bela Vista", logradouro: "Rua Goiás", numero: "1120",
    latitude: -16.7205, longitude: -49.2680, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Marcos Vinicius", ultimaVistoria: "2026-06-05", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Quaresmeira%20tree%20Tibouchina%20with%20purple%20blossoms%20on%20green%20corridor%2C%20young%20specimen%2C%20professional%20arboriculture%20documentation&width=400&height=300&seq=map-bv-quaresmeira-010&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-011", codigoCta: "CTA-GO-5208707-BV0011", nomePopular: "Jatobá", nomeCientifico: "Hymenaea courbaril",
    tipo: "Árvore", especie: "Hymenaea courbaril", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Tratamento fitossanitário", dap: 65, altura: 16.8, bairro: "Setor Bela Vista", logradouro: "Praça da Bela Vista", numero: "s/n",
    latitude: -16.7135, longitude: -49.2580, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Gabriel Santos", ultimaVistoria: "2026-06-08", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jatoba%20tree%20Hymenaea%20courbaril%20in%20public%20square%2C%20large%20trunk%2C%20professional%20arboriculture%20photo%2C%20natural%20daylight&width=400&height=300&seq=map-bv-jatoba-011&orientation=landscape",
    camada: ["arvores", "risco_medio"]
  },
  {
    id: "MAP-012", codigoCta: "CTA-GO-5208707-BV0012", nomePopular: "Aroeira", nomeCientifico: "Myracrodruon urundeuva",
    tipo: "Muda", especie: "Myracrodruon urundeuva", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Replantio", dap: 6, altura: 1.8, bairro: "Setor Bela Vista", logradouro: "Rua 5", numero: "88",
    latitude: -16.7218, longitude: -49.2690, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Marcos Vinicius", ultimaVistoria: "2026-05-20", fotos: 2, statusRevisao: "pendente de informação",
    fotoUrl: "https://readdy.ai/api/search-image?query=Young%20aroeira%20sapling%20with%20wooden%20stake%20on%20green%20corridor%2C%20professional%20arboriculture%20documentation%2C%20urban%20reforestation&width=400&height=300&seq=map-bv-aroeira-012&orientation=landscape",
    camada: ["mudas"]
  },
  {
    id: "MAP-013", codigoCta: "CTA-GO-5208707-BV0013", nomePopular: "Ipê-roxo", nomeCientifico: "Handroanthus impetiginosus",
    tipo: "Árvore", especie: "Handroanthus impetiginosus", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 42, altura: 11.0, bairro: "Setor Bela Vista", logradouro: "Rua 3", numero: "220",
    latitude: -16.7125, longitude: -49.2575, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Carlos Mendes", ultimaVistoria: "2026-06-20", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Purple%20trumpet%20tree%20Handroanthus%20impetiginosus%20on%20urban%20sidewalk%2C%20professional%20arboriculture%20photo%2C%20clean%20street%20background&width=400&height=300&seq=map-bv-iperoxo-013&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-014", codigoCta: "CTA-GO-5208707-BV0014", nomePopular: "Copaíba", nomeCientifico: "Copaifera langsdorffii",
    tipo: "Árvore", especie: "Copaifera langsdorffii", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Poda de limpeza", dap: 58, altura: 15.0, bairro: "Setor Bela Vista", logradouro: "Rua das Acácias", numero: "445",
    latitude: -16.7160, longitude: -49.2630, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-06-14", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Copaiba%20tree%20in%20urban%20residential%20area%2C%20tall%20specimen%2C%20professional%20arboriculture%20documentation%2C%20natural%20lighting&width=400&height=300&seq=map-bv-copaiba-014&orientation=landscape",
    camada: ["arvores", "risco_medio", "poda_recomendada"]
  },
  {
    id: "MAP-015", codigoCta: "CTA-GO-5208707-BV0015", nomePopular: "Pequi", nomeCientifico: "Caryocar brasiliense",
    tipo: "Árvore", especie: "Caryocar brasiliense", estadoFitossanitario: "regular", classeRisco: "alto",
    recomendacao: "Poda corretiva", dap: 48, altura: 13.0, bairro: "Setor Bela Vista", logradouro: "Rua das Orquídeas", numero: "670",
    latitude: -16.7188, longitude: -49.2650, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Fernanda Lima", ultimaVistoria: "2026-06-10", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Pequi%20tree%20Caryocar%20brasiliense%20with%20broad%20canopy%20in%20urban%20park%2C%20professional%20arboriculture%20photo%2C%20natural%20cerrado%20vegetation%20context&width=400&height=300&seq=map-bv-pequi-015&orientation=landscape",
    camada: ["arvores", "risco_alto", "poda_recomendada"]
  },
  {
    id: "MAP-016", codigoCta: "CTA-GO-5208707-BV0016", nomePopular: "Angico", nomeCientifico: "Anadenanthera colubrina",
    tipo: "Árvore", especie: "Anadenanthera colubrina", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 38, altura: 10.5, bairro: "Setor Bela Vista", logradouro: "Rua 7", numero: "150",
    latitude: -16.7108, longitude: -49.2565, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Gabriel Santos", ultimaVistoria: "2026-06-05", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Angico%20tree%20Anadenanthera%20on%20urban%20street%2C%20tall%20specimen%20with%20fine%20foliage%2C%20professional%20arboriculture%20photo%2C%20bright%20daylight&width=400&height=300&seq=map-bv-angico-016&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-017", codigoCta: "CTA-GO-5208707-BV0017", nomePopular: "Tamboril", nomeCientifico: "Enterolobium contortisiliquum",
    tipo: "Árvore", especie: "Enterolobium contortisiliquum", estadoFitossanitario: "ruim", classeRisco: "alto",
    recomendacao: "Poda emergencial", dap: 85, altura: 19.0, bairro: "Setor Bela Vista", logradouro: "Av. Bela Vista", numero: "1200",
    latitude: -16.7150, longitude: -49.2615, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-08", fotos: 8, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Large%20tamboril%20tree%20with%20cracked%20branches%20on%20urban%20avenue%2C%20risk%20assessment%20context%2C%20professional%20arboriculture%20photo&width=400&height=300&seq=map-bv-tamboril-017&orientation=landscape",
    camada: ["arvores", "risco_alto", "poda_recomendada"]
  },
  {
    id: "MAP-018", codigoCta: "CTA-GO-5208707-BV0018", nomePopular: "Goiabeira", nomeCientifico: "Psidium guajava",
    tipo: "Árvore", especie: "Psidium guajava", estadoFitossanitario: "regular", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 22, altura: 6.5, bairro: "Setor Bela Vista", logradouro: "Rua Copacabana", numero: "380",
    latitude: -16.7195, longitude: -49.2670, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-18", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Guava%20tree%20on%20residential%20street%2C%20medium%20size%2C%20professional%20arboriculture%20documentation%2C%20natural%20lighting&width=400&height=300&seq=map-bv-goiabeira-018&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-019", codigoCta: "CTA-GO-5208707-BV0019", nomePopular: "Paineira", nomeCientifico: "Ceiba speciosa",
    tipo: "Árvore", especie: "Ceiba speciosa", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 55, altura: 16.0, bairro: "Setor Bela Vista", logradouro: "Rua das Palmeiras", numero: "230",
    latitude: -16.7168, longitude: -49.2645, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-12", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Paineira%20tree%20Ceiba%20speciosa%20with%20spiky%20trunk%20in%20park%20setting%2C%20professional%20arboriculture%20photo%2C%20natural%20daylight&width=400&height=300&seq=map-bv-paineira-019&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-020", codigoCta: "CTA-GO-5208707-BV0020", nomePopular: "Grevílea", nomeCientifico: "Grevillea robusta",
    tipo: "Árvore", especie: "Grevillea robusta", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Poda de limpeza", dap: 42, altura: 14.5, bairro: "Setor Bela Vista", logradouro: "Av. Bela Vista", numero: "920",
    latitude: -16.7142, longitude: -49.2608, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Carlos Mendes", ultimaVistoria: "2026-06-16", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Grevillea%20tree%20on%20urban%20avenue%2C%20tall%20specimen%20with%20fern-like%20foliage%2C%20professional%20arboriculture%20documentation&width=400&height=300&seq=map-bv-grevilea-020&orientation=landscape",
    camada: ["arvores", "risco_medio", "poda_recomendada"]
  },
  {
    id: "MAP-021", codigoCta: "CTA-GO-5208707-BV0021", nomePopular: "Açaí", nomeCientifico: "Euterpe oleracea",
    tipo: "Palmeira", especie: "Euterpe oleracea", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 18, altura: 8.0, bairro: "Setor Bela Vista", logradouro: "Alameda dos Buritis", numero: "180",
    latitude: -16.7115, longitude: -49.2578, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-19", fotos: 2, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Acai%20palm%20Euterpe%20oleracea%20cluster%20on%20urban%20sidewalk%2C%20professional%20arboriculture%20photo%2C%20tropical%20urban%20context&width=400&height=300&seq=map-bv-acai-021&orientation=landscape",
    camada: ["palmeiras"]
  },
  {
    id: "MAP-022", codigoCta: "CTA-GO-5208707-BV0022", nomePopular: "Embaúba", nomeCientifico: "Cecropia pachystachya",
    tipo: "Árvore", especie: "Cecropia pachystachya", estadoFitossanitario: "regular", classeRisco: "alto",
    recomendacao: "Poda corretiva", dap: 32, altura: 8.5, bairro: "Setor Bela Vista", logradouro: "Rua 5", numero: "310",
    latitude: -16.7220, longitude: -49.2685, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Fernanda Lima", ultimaVistoria: "2026-06-06", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Embauba%20tree%20Cecropia%20with%20hollow%20trunk%20in%20urban%20park%2C%20professional%20arboriculture%20risk%20context%2C%20natural%20lighting&width=400&height=300&seq=map-bv-embauba-022&orientation=landscape",
    camada: ["arvores", "risco_alto", "poda_recomendada"]
  },
  {
    id: "MAP-023", codigoCta: "CTA-GO-5208707-BV0023", nomePopular: "Ingá", nomeCientifico: "Inga edulis",
    tipo: "Árvore", especie: "Inga edulis", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 35, altura: 9.0, bairro: "Setor Bela Vista", logradouro: "Rua Goiás", numero: "890",
    latitude: -16.7208, longitude: -49.2675, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Marcos Vinicius", ultimaVistoria: "2026-06-03", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Inga%20tree%20on%20green%20corridor%20with%20broad%20canopy%2C%20professional%20arboriculture%20documentation%2C%20urban%20reforestation%20context&width=400&height=300&seq=map-bv-inga-023&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-024", codigoCta: "CTA-GO-5208707-BV0024", nomePopular: "Canafístula", nomeCientifico: "Peltophorum dubium",
    tipo: "Árvore", especie: "Peltophorum dubium", estadoFitossanitario: "ruim", classeRisco: "critico",
    recomendacao: "Supressão", dap: 62, altura: 17.0, bairro: "Setor Bela Vista", logradouro: "Rua das Orquídeas", numero: "145",
    latitude: -16.7180, longitude: -49.2655, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-04", fotos: 7, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Damaged%20Peltophorum%20tree%20with%20severe%20trunk%20cavity%2C%20risk%20of%20fall%2C%20professional%20arboriculture%20emergency%20assessment%20photo&width=400&height=300&seq=map-bv-canafistula-024&orientation=landscape",
    camada: ["arvores", "risco_critico", "supressao"]
  },
  {
    id: "MAP-025", codigoCta: "CTA-GO-5208707-BV0025", nomePopular: "Pitanga", nomeCientifico: "Eugenia uniflora",
    tipo: "Árvore", especie: "Eugenia uniflora", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 15, altura: 4.5, bairro: "Setor Bela Vista", logradouro: "Rua 3", numero: "460",
    latitude: -16.7120, longitude: -49.2570, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Gabriel Santos", ultimaVistoria: "2026-06-02", fotos: 2, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Pitanga%20tree%20Eugenia%20uniflora%20on%20residential%20street%2C%20small%20fruit%20tree%2C%20professional%20arboriculture%20documentation&width=400&height=300&seq=map-bv-pitanga-025&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-026", codigoCta: "CTA-GO-5208707-BV0026", nomePopular: "Jequitibá", nomeCientifico: "Cariniana estrellensis",
    tipo: "Árvore", especie: "Cariniana estrellensis", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 72, altura: 22.0, bairro: "Setor Bela Vista", logradouro: "Praça da Bela Vista", numero: "s/n",
    latitude: -16.7148, longitude: -49.2590, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-10", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jequitiba%20tree%20Cariniana%20with%20massive%20trunk%20in%20park%2C%20ancient%20specimen%2C%20professional%20arboriculture%20photo%2C%20natural%20daylight&width=400&height=300&seq=map-bv-jequitiba-026&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-027", codigoCta: "CTA-GO-5208707-BV0027", nomePopular: "Cedro", nomeCientifico: "Cedrela fissilis",
    tipo: "Árvore", especie: "Cedrela fissilis", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Tratamento fitossanitário", dap: 48, altura: 15.5, bairro: "Setor Bela Vista", logradouro: "Rua das Acácias", numero: "780",
    latitude: -16.7155, longitude: -49.2620, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Rafael Torres", ultimaVistoria: "2026-06-08", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Cedro%20tree%20Cedrela%20fissilis%20in%20public%20square%2C%20tall%20specimen%2C%20professional%20arboriculture%20photo%2C%20bright%20daylight&width=400&height=300&seq=map-bv-cedro-027&orientation=landscape",
    camada: ["arvores", "risco_medio"]
  },
  {
    id: "MAP-028", codigoCta: "CTA-GO-5208707-BV0028", nomePopular: "Jamelão", nomeCientifico: "Syzygium cumini",
    tipo: "Árvore", especie: "Syzygium cumini", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 55, altura: 14.0, bairro: "Setor Bela Vista", logradouro: "Rua 7", numero: "340",
    latitude: -16.7105, longitude: -49.2560, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Carlos Mendes", ultimaVistoria: "2026-06-15", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jamelao%20tree%20Syzygium%20cumini%20on%20urban%20street%2C%20dense%20canopy%2C%20professional%20arboriculture%20documentation&width=400&height=300&seq=map-bv-jamelao-028&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-029", codigoCta: "CTA-GO-5208707-BV0029", nomePopular: "Amoreira", nomeCientifico: "Morus nigra",
    tipo: "Árvore", especie: "Morus nigra", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Poda de limpeza", dap: 28, altura: 7.0, bairro: "Setor Bela Vista", logradouro: "Rua Copacabana", numero: "510",
    latitude: -16.7198, longitude: -49.2668, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-06-11", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Mulberry%20tree%20Morus%20nigra%20on%20residential%20sidewalk%2C%20professional%20arboriculture%20photo%2C%20natural%20lighting&width=400&height=300&seq=map-bv-amoreira-029&orientation=landscape",
    camada: ["arvores", "risco_medio", "poda_recomendada"]
  },
  {
    id: "MAP-030", codigoCta: "CTA-GO-5208707-BV0030", nomePopular: "Ipê-branco", nomeCientifico: "Tabebuia roseoalba",
    tipo: "Árvore", especie: "Tabebuia roseoalba", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 38, altura: 11.0, bairro: "Setor Bela Vista", logradouro: "Alameda dos Buritis", numero: "620",
    latitude: -16.7110, longitude: -49.2585, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-13", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=White%20trumpet%20tree%20Tabebuia%20on%20urban%20avenue%2C%20professional%20arboriculture%20photo%2C%20bright%20daylight%2C%20clean%20composition&width=400&height=300&seq=map-bv-ipebranco-030&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-031", codigoCta: "CTA-GO-5208707-BV0031", nomePopular: "Gameleira", nomeCientifico: "Ficus gomelleira",
    tipo: "Árvore", especie: "Ficus gomelleira", estadoFitossanitario: "ruim", classeRisco: "alto",
    recomendacao: "Poda emergencial", dap: 105, altura: 24.0, bairro: "Setor Bela Vista", logradouro: "Praça da Bela Vista", numero: "s/n",
    latitude: -16.7130, longitude: -49.2598, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Gabriel Santos", ultimaVistoria: "2026-06-01", fotos: 8, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Massive%20Ficus%20gomelleira%20tree%20in%20public%20square%20with%20extensive%20canopy%2C%20professional%20arboriculture%20risk%20assessment%20photo&width=400&height=300&seq=map-bv-gameleira-031&orientation=landscape",
    camada: ["arvores", "risco_alto", "poda_recomendada"]
  },
  {
    id: "MAP-032", codigoCta: "CTA-GO-5208707-BV0032", nomePopular: "Mutamba", nomeCientifico: "Guazuma ulmifolia",
    tipo: "Árvore", especie: "Guazuma ulmifolia", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Monitorar", dap: 30, altura: 8.0, bairro: "Setor Bela Vista", logradouro: "Rua das Palmeiras", numero: "420",
    latitude: -16.7170, longitude: -49.2648, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Marcos Vinicius", ultimaVistoria: "2026-05-28", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Mutamba%20tree%20Guazuma%20ulmifolia%20on%20green%20corridor%2C%20medium%20specimen%2C%20professional%20arboriculture%20documentation&width=400&height=300&seq=map-bv-mutamba-032&orientation=landscape",
    camada: ["arvores", "risco_medio"]
  },
  {
    id: "MAP-033", codigoCta: "CTA-GO-5208707-BV0033", nomePopular: "Macaúba", nomeCientifico: "Acrocomia aculeata",
    tipo: "Palmeira", especie: "Acrocomia aculeata", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 25, altura: 10.0, bairro: "Setor Bela Vista", logradouro: "Rua dos Ipês", numero: "340",
    latitude: -16.7178, longitude: -49.2635, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-09", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Macauba%20palm%20Acrocomia%20aculeata%20in%20park%20setting%20with%20spiny%20trunk%2C%20professional%20arboriculture%20photo&width=400&height=300&seq=map-bv-macauba-033&orientation=landscape",
    camada: ["palmeiras"]
  },
  {
    id: "MAP-034", codigoCta: "CTA-GO-5208707-BV0034", nomePopular: "Mogno", nomeCientifico: "Swietenia macrophylla",
    tipo: "Árvore", especie: "Swietenia macrophylla", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 42, altura: 13.5, bairro: "Setor Bela Vista", logradouro: "Rua 7", numero: "560",
    latitude: -16.7100, longitude: -49.2568, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Gabriel Santos", ultimaVistoria: "2026-06-03", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Mahogany%20tree%20Swietenia%20on%20urban%20street%2C%20tall%20straight%20trunk%2C%20professional%20arboriculture%20photo%2C%20bright%20daylight&width=400&height=300&seq=map-bv-mogno-034&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-035", codigoCta: "CTA-GO-5208707-BV0035", nomePopular: "Gonçalo-alves", nomeCientifico: "Astronium fraxinifolium",
    tipo: "Árvore", especie: "Astronium fraxinifolium", estadoFitossanitario: "regular", classeRisco: "alto",
    recomendacao: "Poda corretiva", dap: 52, altura: 16.0, bairro: "Setor Bela Vista", logradouro: "Rua das Orquídeas", numero: "890",
    latitude: -16.7185, longitude: -49.2658, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Fernanda Lima", ultimaVistoria: "2026-06-02", fotos: 5, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Goncalo%20alves%20tree%20Astronium%20near%20protected%20area%2C%20professional%20arboriculture%20photo%2C%20natural%20cerrado%20context&width=400&height=300&seq=map-bv-goncalo-035&orientation=landscape",
    camada: ["arvores", "risco_alto", "poda_recomendada"]
  },
  {
    id: "MAP-036", codigoCta: "CTA-GO-5208707-BV0036", nomePopular: "Buriti", nomeCientifico: "Mauritia flexuosa",
    tipo: "Palmeira", especie: "Mauritia flexuosa", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 38, altura: 18.0, bairro: "Setor Bela Vista", logradouro: "Área Verde Córrego Cascavel", numero: "s/n",
    latitude: -16.7230, longitude: -49.2695, projeto: "Revitalização Verde — Praças Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-07", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Buriti%20palm%20Mauritia%20flexuosa%20near%20water%20in%20park%2C%20tall%20elegant%20specimen%2C%20professional%20arboriculture%20photo&width=400&height=300&seq=map-bv-buriti-036&orientation=landscape",
    camada: ["palmeiras"]
  },
  {
    id: "MAP-037", codigoCta: "CTA-GO-5208707-BV0037", nomePopular: "Babaçu", nomeCientifico: "Attalea speciosa",
    tipo: "Palmeira", especie: "Attalea speciosa", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Monitorar", dap: 32, altura: 12.0, bairro: "Setor Bela Vista", logradouro: "Rua 5", numero: "190",
    latitude: -16.7225, longitude: -49.2688, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Fernanda Lima", ultimaVistoria: "2026-05-30", fotos: 3, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Babacu%20palm%20Attalea%20speciosa%20in%20protected%20area%2C%20professional%20arboriculture%20documentation%2C%20natural%20cerrado%20vegetation&width=400&height=300&seq=map-bv-babacu-037&orientation=landscape",
    camada: ["palmeiras", "risco_medio"]
  },
  {
    id: "MAP-038", codigoCta: "CTA-GO-5208707-BV0038", nomePopular: "Jatobá-do-cerrado", nomeCientifico: "Hymenaea stigonocarpa",
    tipo: "Árvore", especie: "Hymenaea stigonocarpa", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 45, altura: 12.0, bairro: "Setor Bela Vista", logradouro: "Rua dos Ipês", numero: "670",
    latitude: -16.7170, longitude: -49.2632, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Juliana Costa", ultimaVistoria: "2026-06-05", fotos: 4, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jatoba%20do%20cerrado%20tree%20Hymenaea%20in%20park%2C%20broad%20canopy%2C%20professional%20arboriculture%20photo%2C%20natural%20daylight&width=400&height=300&seq=map-bv-jatoba-cerrado-038&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-039", codigoCta: "CTA-GO-5208707-BV0039", nomePopular: "Ipê-rosa", nomeCientifico: "Handroanthus heptaphyllus",
    tipo: "Árvore", especie: "Handroanthus heptaphyllus", estadoFitossanitario: "ruim", classeRisco: "critico",
    recomendacao: "Supressão", dap: 35, altura: 9.0, bairro: "Setor Bela Vista", logradouro: "Rua Goiás", numero: "450",
    latitude: -16.7210, longitude: -49.2682, projeto: "Monitoramento de Árvores — Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-05-25", fotos: 6, statusRevisao: "em revisão",
    fotoUrl: "https://readdy.ai/api/search-image?query=Damaged%20Handroanthus%20tree%20with%20severe%20trunk%20decay%2C%20risk%20of%20fall%2C%20professional%20arboriculture%20emergency%20photo&width=400&height=300&seq=map-bv-iperosa-039&orientation=landscape",
    camada: ["arvores", "risco_critico", "supressao"]
  },
  {
    id: "MAP-040", codigoCta: "CTA-GO-5208707-BV0040", nomePopular: "Grumixama", nomeCientifico: "Eugenia brasiliensis",
    tipo: "Árvore", especie: "Eugenia brasiliensis", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Monitorar", dap: 20, altura: 6.0, bairro: "Setor Bela Vista", logradouro: "Rua 3", numero: "180",
    latitude: -16.7128, longitude: -49.2572, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Ana Oliveira", ultimaVistoria: "2026-06-09", fotos: 2, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Grumixama%20tree%20Eugenia%20brasiliensis%20on%20residential%20sidewalk%2C%20professional%20arboriculture%20documentation%2C%20natural%20lighting&width=400&height=300&seq=map-bv-grumixama-040&orientation=landscape",
    camada: ["arvores"]
  },
  {
    id: "MAP-041", codigoCta: "CTA-GO-5208707-BV0041", nomePopular: "Mirindiba", nomeCientifico: "Lafoensia pacari",
    tipo: "Árvore", especie: "Lafoensia pacari", estadoFitossanitario: "regular", classeRisco: "medio",
    recomendacao: "Tratamento fitossanitário", dap: 28, altura: 7.5, bairro: "Setor Bela Vista", logradouro: "Rua Copacabana", numero: "670",
    latitude: -16.7190, longitude: -49.2672, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Rafael Torres", ultimaVistoria: "2026-06-04", fotos: 3, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Mirindiba%20tree%20Lafoensia%20in%20public%20square%2C%20medium%20specimen%2C%20professional%20arboriculture%20photo&width=400&height=300&seq=map-bv-mirindiba-041&orientation=landscape",
    camada: ["arvores", "risco_medio"]
  },
  {
    id: "MAP-042", codigoCta: "CTA-GO-5208707-BV0042", nomePopular: "Jerivá", nomeCientifico: "Syagrus romanzoffiana",
    tipo: "Palmeira", especie: "Syagrus romanzoffiana", estadoFitossanitario: "bom", classeRisco: "baixo",
    recomendacao: "Sem intervenção", dap: 22, altura: 9.0, bairro: "Setor Bela Vista", logradouro: "Alameda dos Buritis", numero: "240",
    latitude: -16.7112, longitude: -49.2582, projeto: "Inventário Arbóreo — Setor Bela Vista",
    tecnico: "Pedro Alves", ultimaVistoria: "2026-06-11", fotos: 2, statusRevisao: "validada",
    fotoUrl: "https://readdy.ai/api/search-image?query=Jeriva%20palm%20Syagrus%20romanzoffiana%20on%20urban%20avenue%2C%20elegant%20fronds%2C%20professional%20arboriculture%20photo&width=400&height=300&seq=map-bv-jeriva-042&orientation=landscape",
    camada: ["palmeiras"]
  },
];

export const areasVerdesMapa: AreaVerdeMap[] = [
  {
    id: "AV-001",
    nome: "Praça da Bela Vista",
    tipo: "Praça Pública",
    area: 6.2,
    arvoresDentro: 187,
    riscoCritico: 4,
    co2eEstimado: 52,
    bairro: "Setor Bela Vista",
    latitude: -16.7135,
    longitude: -49.2590,
    coordenadas: [
      [-16.7120, -49.2575],
      [-16.7120, -49.2605],
      [-16.7150, -49.2605],
      [-16.7150, -49.2575],
    ],
    documentosVinculados: 5,
    status: "Ativa",
    camada: ["areas_verdes"]
  },
  {
    id: "AV-002",
    nome: "Área Verde Córrego Cascavel",
    tipo: "APP Urbana",
    area: 28,
    arvoresDentro: 640,
    riscoCritico: 8,
    co2eEstimado: 180,
    bairro: "Setor Bela Vista",
    latitude: -16.7230,
    longitude: -49.2695,
    coordenadas: [
      [-16.7205, -49.2660],
      [-16.7205, -49.2720],
      [-16.7255, -49.2720],
      [-16.7255, -49.2660],
    ],
    documentosVinculados: 8,
    status: "Ativa",
    camada: ["areas_verdes", "carbono"]
  },
];

export const ucsMapa: UCMap[] = [
  {
    id: "UC-001",
    nome: "Parque Municipal Bela Vista",
    tipo: "Unidade de Conservação Municipal",
    area: 42,
    arvoresDentro: 1240,
    riscoCritico: 6,
    co2eEstimado: 380,
    bairro: "Setor Bela Vista",
    latitude: -16.7080,
    longitude: -49.2550,
    coordenadas: [
      [-16.7060, -49.2520],
      [-16.7060, -49.2580],
      [-16.7100, -49.2580],
      [-16.7100, -49.2520],
    ],
    documentosVinculados: 10,
    status: "Ativa",
    orgaoGestor: "Secretaria Municipal de Meio Ambiente — Goiânia",
    camada: ["ucs"]
  },
];

export const projetosAreasMapa: ProjetoMapArea[] = [
  {
    id: "PRJ-AREA-001",
    nome: "Inventário Arbóreo — Setor Bela Vista",
    latitude: -16.7145,
    longitude: -49.2610,
    coordenadas: [
      [-16.7080, -49.2540],
      [-16.7080, -49.2680],
      [-16.7210, -49.2680],
      [-16.7210, -49.2540],
    ],
    camada: ["projetos"]
  },
  {
    id: "PRJ-AREA-002",
    nome: "Revitalização Verde — Praças Bela Vista",
    latitude: -16.7135,
    longitude: -49.2590,
    coordenadas: [
      [-16.7120, -49.2575],
      [-16.7120, -49.2605],
      [-16.7150, -49.2605],
      [-16.7150, -49.2575],
    ],
    camada: ["projetos", "carbono"]
  },
];

export const mapStats = {
  arvoresVisiveis: 1187,
  riscoCritico: 15,
  podaRecomendada: 89,
  areasVerdes: 5,
  ucs: 1,
};